var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"mr-2 h-5 w-5 text-green-400",attrs:{"fill":"none","stroke":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M5 13l4 4L19 7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }